/**
 * Helper for getting an URL to an asset within the sitepackage.
 *
 * @param {string} asset Path to an asset within the sitepackage
 * @returns {string} Web accessible URL to the asset
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default function (asset: string): string {
  return '/typo3conf/ext/sitepackage/' + asset;
}
